module.exports = __webpack_public_path__ + "static/media/grid-item-b2.a80fa141.png";